module.exports = __webpack_public_path__ + "img/s1-3-ja.f1a04cc8.jpg";